import { isCustomizedType, reduce } from "et3-type-guards";

import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { TCorePage } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetMyCSRPerformanceData = async ({
  startDate,
  endDate
}: {
  startDate: Date;
  endDate: Date;
}): Promise<{
  data: {
    activeTime: number;
    pageName: TCorePage;
    numberOfEvents: number;
    eventPerHour: number;
  }[];
  status: string;
  code: string;
}> => {
  const { status, data, et3Error } = await post<
    {
      activeTime: number;
      pageName: TCorePage;
      numberOfEvents: number;
      eventPerHour: number;
    }[]
  >(`csr/getMyCSRPerformance`, {
    //sending this in this way beacuse on the server send the date as object is changing it
    startDateObject: getDateAsObject(startDate),
    endDateObject: getDateAsObject(endDate)
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (
    status === "ERROR" &&
    isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      et3Error
    )
  ) {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [
        {
          activeTime: 0,
          pageName: "",
          numberOfEvents: 0,
          eventPerHour: 0
        }
      ],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: [
        {
          activeTime: 0,
          pageName: "",
          numberOfEvents: 0,
          eventPerHour: 0
        }
      ],
      status: "ERROR",
      code: "ERROR"
    };
  }
};
